import React from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import CssBaseline from "@material-ui/core/CssBaseline";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import Container from "@material-ui/core/Container";
import Slide from "@material-ui/core/Slide";
import logo from "./assets/images/JioLogo.png";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import TermsCondition from "./components/TermsCondition/TermsCondition";
import ScrollToTop from "./components/shared/ScrollToTop";
import { HashRouter, Switch, Route, Link, Redirect } from "react-router-dom";
import "./App.css";

function HideOnScroll(props) {
  const { children, window } = props;

  const trigger = useScrollTrigger({ target: window ? window() : undefined });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

HideOnScroll.propTypes = {
  children: PropTypes.element.isRequired,
  window: PropTypes.func,
};

export default function App(props) {
  return (
    <React.Fragment>
      <CssBaseline />
      <HideOnScroll {...props}>
        <AppBar>
          <Toolbar>
            <div>
              <img className="jio-logo" src={logo} alt="JIO Logo" />
            </div>
          </Toolbar>
        </AppBar>
      </HideOnScroll>
      <Toolbar />
      <Container>
        <HashRouter>
          <ScrollToTop />
          <Switch>
            <Route exact path="/">
              <Redirect to="/terms-conditions" />
            </Route>
            <Route exact path="/terms-conditions">
              <TermsCondition />
            </Route>
            <Route exact path="/privacy-policy">
              <PrivacyPolicy />
            </Route>
            <Route path="*">
              <h1>Page Not Found</h1>
            </Route>
          </Switch>
          <footer>
            <div className="footer-links">
              <span>
                <Link to="/terms-conditions">Terms & Conditions</Link>
              </span>
              <span id="privacy-policy">
                <Link to="/privacy-policy">Privacy Policy</Link>
              </span>
            </div>
            <p className="copy-right">
              <p>
                Copyright © {new Date().getFullYear()} JCA Mobile Application.
              </p>
              <p>All rights reserved.</p>
            </p>
          </footer>
        </HashRouter>
      </Container>
    </React.Fragment>
  );
}
